const aamaliServicesStyle = {
	modalWrapper: {
		padding: '0rem 1rem 2rem 0rem',
		marginLeft: '2rem',
	},
	modalBody: {
		margin: '0.8rem',
	},
	modalButton:{
		width: '100%',
		'margin-top': '1rem'
	},
	iconWrapper: {
		display: 'flex',
	},
	statusText: {
		margin: '.1rem 0 0 0.4rem',
		fontSize: 'medium',
	},
	navButtons:{
		float: 'right',
		'margin-top': '2rem'
	},
	navButtonWrapper: {
		display: 'flex',
		'flex-direction': 'row-reverse',
		padding: '2rem',
	},
};
export default aamaliServicesStyle;